import { useState,useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  MenuItem,
  Divider,
} from "@mui/material";
import { useNavigate, useSearchParams,useParams } from "react-router-dom";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import * as services from "./../../services/customer";

const initialState = {
  // เดิม
  farmerCode: "",
  prefix: "",
  firstName: "",
  lastName: "",
  citizenId: "",
  birthDate: "",
  age: 0,

  registerAddress: "",
  currentAddress: "",
  phone: "",
  email: "",

  mainJob: "",
  mainJobOther: "",
  subJob: "",

  // 🔹 เพิ่มตามฟอร์ม
  agriYears: 0,

  // ส่วนที่ 2
  totalLandRai: 0,
  totalLandNgan: 0,
  totalLandWa: 0,

  agriLandRai: 0,
  agriLandNgan: 0,
  agriLandWa: 0,

  rentedLandFrom: "",
  landLocation: "",
  irrigationZone: "",

  // ส่วนที่ 3
  cropTypes: "",
  cropAreaRai: "",
  cropAreaNgan: "",
  cropAreaWa: "",

  seedVariety: "",
  waterSource: "",
  startPlantYear: "",
  expectedYield: "",
  postHarvestManage: "",
  postHarvestManageOther: "",

  harvestPeriod: "",

  // ส่วนที่ 4
  problemSoilWaterClimate: "",
  problemDisease: "",
  problemCost: "",
  problemLabor: "",
  problemMarket: "",
  problemOther: "",
  irrigationZoneOther: "",

  waterSourceOther: "",

  problemSoilWaterClimateOther: "",
  problemDiseaseOther: "",
  problemCostOther: "",
  problemLaborOther: "",
  problemMarketOther: "",
};

export default function FarmerForm({ mode = "add", defaultData }) {
  const navigate = useNavigate();
  const [form, setForm] = useState(defaultData || initialState);
  const [searchParams] = useSearchParams();
  const customer_id = searchParams.get("customer_id");
   const { id } = useParams(); 
  console.log(id);

  useEffect(() => {
    if (mode === "edit" && id) {
      fetchFarmerDetail(id);
    }
  }, [mode, id]);

  const fetchFarmerDetail = async (id) => {
    try {
      const res = await services.getCustomeFarmerByID(id);
      const data = res.data?.data;

      if (!data) return;

      setForm({
        ...initialState,
        ...data,

        // กรณี field ที่มี other
        mainJob: [
          "เกษตรกร",
          "รับจ้างทั่วไป",
          "รับราชการ/พนักงานรัฐวิสาหกิจ",
          "พนักงานบริษัท",
        ].includes(data.mainJob)
          ? data.mainJob
          : "other",
        mainJobOther: [
          "เกษตรกร",
          "รับจ้างทั่วไป",
          "รับราชการ/พนักงานรัฐวิสาหกิจ",
          "พนักงานบริษัท",
        ].includes(data.mainJob)
          ? ""
          : data.mainJob,

        waterSource: [
          "น้ำฝน",
          "ชลประทาน",
          "บ่อบาดาล",
          "คลอง/แหล่งน้ำธรรมชาติ",
        ].includes(data.waterSource)
          ? data.waterSource
          : "other",
        waterSourceOther: [
          "น้ำฝน",
          "ชลประทาน",
          "บ่อบาดาล",
          "คลอง/แหล่งน้ำธรรมชาติ",
        ].includes(data.waterSource)
          ? ""
          : data.waterSource,
      });
    } catch (err) {
      console.error("โหลดข้อมูลเกษตรกรไม่สำเร็จ", err);
    }
  };

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    const rawPayload = {
      ...form,
      customerId: Number(customer_id),
      // อาชีพหลัก
      mainJob: form.mainJob === "other" ? form.mainJobOther : form.mainJob,

      // แหล่งน้ำ
      waterSource:
        form.waterSource === "other" ? form.waterSourceOther : form.waterSource,

      // การจัดการหลังเก็บเกี่ยว
      postHarvestManage:
        form.postHarvestManage === "other"
          ? form.postHarvestManageOther
          : form.postHarvestManage,
    };

    // Filter out empty values
    const payload = {};
    for (const key in rawPayload) {
      if (rawPayload[key] !== "" && rawPayload[key] !== null && rawPayload[key] !== undefined) {
        payload[key] = rawPayload[key];
      }
    }

    try {
      if (mode === "add") {
        try {
          let res = await services.addCustomeFarmer(payload);
          if (res.data.success) {
            alert("เพิ่มเกษตรกรสำเร็จ");
          }
          navigate(-1);
        } catch (error) {
          alert("เพิ่มเกษตรกรไม่สำเร็จ");
          console.error("Error add customers farmer:", error);
        }
      } else {
        try {
          let res = await services.editCustomeFarmer(payload, id);
          if (res.data.success) {
            alert("แก้ไขเกษตรกรสำเร็จ");
          }
          // navigate(-1);
        } catch (error) {
          console.error("Error fetching customers:", error);
        }
      }
    } catch (err) {
      console.error(err);
      alert("บันทึกข้อมูลไม่สำเร็จ");
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      {/* <AppBreadcrumbs /> */}
      <Typography variant="h6">
        {mode === "add" ? "เพิ่มข้อมูลเกษตรกร" : "แก้ไขข้อมูลเกษตรกร"}
      </Typography>

      {/* ข้อมูลส่วนตัว */}
      <Divider sx={{ my: 2 }}>
        {" "}
        1. ส่วนที่ 1: ข้อมูลทั่วไปของเกษตรกร/ครัวเรือน
      </Divider>
      <Typography sx={{ m: 1 }}>
        {" "}
        *ส่วนนี้เป็นข้อมูลพื้นฐานของเกษตรกรที่เป็นหัวหน้าครัวเรือน
        หรือผู้ที่รับผิดชอบหลักในการทำกิจกรรมทางการเกษตร
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="รหัสเกษตรกร"
            name="farmerCode"
            value={form.farmerCode}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            select
            fullWidth
            label="คำนำหน้า"
            name="prefix"
            value={form.prefix}
            onChange={handleChange}
          >
            <MenuItem value="นาย">นาย</MenuItem>
            <MenuItem value="นาง">นาง</MenuItem>
            <MenuItem value="นางสาว">นางสาว</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="ชื่อ"
            name="firstName"
            value={form.firstName}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="นามสกุล"
            name="lastName"
            value={form.lastName}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="เลขบัตรประชาชน"
            name="citizenId"
            value={form.citizenId}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <TextField
            type="date"
            fullWidth
            label="วันเกิด"
            InputLabelProps={{ shrink: true }}
            name="birthDate"
            value={form.birthDate}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <TextField
            fullWidth
            label="อายุ"
            name="age"
            value={form.age}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      {/* ติดต่อ */}
      <Divider sx={{ my: 2 }}>ข้อมูลการติดต่อ</Divider>
      <TextField
        fullWidth
        label="ที่อยู่ตามทะเบียนบ้าน"
        name="registerAddress"
        value={form.registerAddress}
        onChange={handleChange}
      />
      <TextField
        sx={{ mt: 2 }}
        fullWidth
        label="ที่อยู่ปัจจุบัน(ถ้าแตกต่างจากทะเบียนบ้าน)"
        name="currentAddress"
        value={form.currentAddress}
        onChange={handleChange}
      />

      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="เบอร์โทรศัพท์(มือถือ/บ้าน)"
            name="phone"
            value={form.phone}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="E-mail(ถ้ามี)"
            name="email"
            value={form.email}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      {/* อาชีพ */}
      <Divider sx={{ my: 3 }}>ลักษณะการประกอบอาชีพ</Divider>
      <Grid container spacing={2}>
        <Grid item xs={4} md={4}>
          <TextField
            select
            fullWidth
            label="อาชีพหลัก"
            name="mainJob"
            value={form.mainJob}
            onChange={handleChange}
          >
            <MenuItem value="เกษตรกร">เกษตรกร</MenuItem>
            <MenuItem value="รับจ้างทั่วไป">รับจ้างทั่วไป</MenuItem>
            <MenuItem value="รับราชการ/พนักงานรัฐวิสาหกิจ">
              รับราชการ/พนักงานรัฐวิสาหกิจ
            </MenuItem>
            <MenuItem value="พนักงานบริษัท">พนักงานบริษัท</MenuItem>
            <MenuItem value="other">อื่นๆ ระบุ</MenuItem>
          </TextField>
        </Grid>
        {form.mainJob === "other" && (
          <Grid item xs={4} md={4}>
            <TextField
              fullWidth
              label="ระบุอาชีพหลักอื่นๆ"
              name="mainJobOther"
              value={form.mainJobOther}
              onChange={handleChange}
            />
          </Grid>
        )}

        <Grid item xs={4} md={4}>
          <TextField
            fullWidth
            label="อาชีพรอง(ถ้ามี)"
            name="subJob"
            value={form.subJob}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={4} md={3}>
          <TextField
            fullWidth
            label="จำนวนปีที่ประกอบอาชีพเกษตรกรรม"
            name="agriYears"
            type="number"
            value={form.agriYears}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
      <Divider sx={{ my: 3 }}>
        2. ส่วนที่ 2: ข้อมูลพื้นที่และเอกสารสิทธิ์
      </Divider>
      <Typography sx={{ m: 1 }}>
        ส่วนนี้เป็นข้อมูลเกี่ยวกับที่ดินที่ใช้ในการเกษตร และสิทธิการถือครอง
      </Typography>
      <Typography sx={{ m: 1 }}>
        พื้นที่ทั้งหมดที่ถือครอง (รวมพื้นที่เกษตรและที่อยู่อาศัย)
      </Typography>

      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={4}>
          <TextField
            label="ไร่"
            name="totalLandRai"
            value={form.totalLandRai}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="งาน"
            name="totalLandNgan"
            value={form.totalLandNgan}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="ตารางวา"
            name="totalLandWa"
            value={form.totalLandWa}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
      </Grid>

      <Typography sx={{ mt: 1 }}>พื้นที่ที่ใช้ในการเกษตร</Typography>

      <Grid container spacing={2}>
        <Grid item xs={4}>
          <TextField
            label="ไร่"
            name="agriLandRai"
            value={form.agriLandRai}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="งาน"
            name="agriLandNgan"
            value={form.agriLandNgan}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="ตารางวา"
            name="agriLandWa"
            value={form.agriLandWa}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
      </Grid>

      <TextField
        sx={{ mt: 2 }}
        fullWidth
        label="ที่ดินเช่า (จากบุคคล/หน่วยงานใด) เนื้อที่..."
        name="rentedLandFrom"
        value={form.rentedLandFrom}
        onChange={handleChange}
      />

      <TextField
        sx={{ mt: 2 }}
        fullWidth
        label="ที่ตั้ง (บ้านเลขที่, หมู่, ตำบล, อำเภอ, จังหวัด)"
        name="landLocation"
        value={form.landLocation}
        onChange={handleChange}
      />

      <TextField
        sx={{ mt: 2 }}
        select
        fullWidth
        label="อยู่ในเขตชลประทานหรือไม่"
        name="irrigationZone"
        value={form.irrigationZone}
        onChange={handleChange}
      >
        <MenuItem value="ในเขต">ในเขต</MenuItem>
        <MenuItem value="นอกเขต">นอกเขต</MenuItem>
      </TextField>
      <Divider sx={{ my: 3 }}>3. ส่วนที่ 3: ข้อมูลกิจกรรมการเกษตร</Divider>
      <Typography sx={{ m: 1 }}>
        3.1 การเพาะปลูกพืช (แยกตามชนิดพืชหลัก)
      </Typography>
      <TextField
        fullWidth
        multiline
        label="ชนิดพืชที่ปลูก  (เช่น ก้านแดง,กระท่อมก้านใบสีเขียว(พันธุ์แตงกวา),ใบกระท่อมยักษ์ใหญ่(หางกั้ง): (ระบุได้มากกว่า 1 ชนิด)"
        name="cropTypes"
        value={form.cropTypes}
        onChange={handleChange}
      />
      <Typography sx={{ m: 1 }}>เนื้อที่ปลูก</Typography>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <TextField
            label="ไร่"
            name="cropAreaRai"
            value={form.cropAreaRai}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="งาน"
            name="cropAreaNgan"
            value={form.cropAreaNgan}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="ตารางวา"
            name="cropAreaWa"
            value={form.cropAreaWa}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
      </Grid>
      <Typography sx={{ m: 1 }}>3.2 พันธุ์ที่ใช้ปลูก</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            select
            fullWidth
            label="แหล่งน้ำที่ใช้"
            name="waterSource"
            value={form.waterSource}
            onChange={handleChange}
          >
            <MenuItem value="น้ำฝน">น้ำฝน</MenuItem>
            <MenuItem value="ชลประทาน">ชลประทาน</MenuItem>
            <MenuItem value="บ่อบาดาล">บ่อบาดาล</MenuItem>
            <MenuItem value="คลอง/แหล่งน้ำธรรมชาติ">
              คลอง/แหล่งน้ำธรรมชาติ
            </MenuItem>
            <MenuItem value="other">อื่นๆ</MenuItem>
          </TextField>
        </Grid>
        {form.waterSource === "other" && (
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="ระบุแหล่งน้ำอื่นๆ"
              name="waterSourceOther"
              value={form.waterSourceOther}
              onChange={handleChange}
            />
          </Grid>
        )}
      </Grid>
      <TextField
        sx={{ mt: 2 }}
        fullWidth
        label="เริ่มต้นการปลูก ปี พ.ศ."
        name="startPlantYear"
        value={form.startPlantYear}
        onChange={handleChange}
      />

      <TextField
        sx={{ mt: 2 }}
        fullWidth
        label="ผลผลิตที่คาดว่าจะได้รับ / ผลผลิตที่ผ่านมา (หน่วย: ตัน/กก./อื่นๆ)"
        name="expectedYield"
        value={form.expectedYield}
        onChange={handleChange}
      />
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            sx={{ mt: 2 }}
            select
            fullWidth
            label="การจัดการหลังการเก็บเกี่ยว (ตาก, บรรจุ, อบ หรืออื่นๆ)"
            name="postHarvestManage"
            value={form.postHarvestManage}
            onChange={handleChange}
          >
            <MenuItem value="ภัยแล้ง">ตาก</MenuItem>
            <MenuItem value="น้ำท่วม">บรรจุ</MenuItem>
            <MenuItem value="ดินเสื่อม">อบ</MenuItem>
            <MenuItem value="other">อื่นๆ</MenuItem>
          </TextField>
        </Grid>

        {form.postHarvestManage === "other" && (
          <Grid item xs={6}>
            <TextField
              sx={{ mt: 2 }}
              fullWidth
              label="ระบุการจัดการหลังการเก็บเกี่ยวอื่นๆ"
              name="postHarvestManageOther"
              value={form.postHarvestManageOther}
              onChange={handleChange}
            />
          </Grid>
        )}
      </Grid>

      <TextField
        sx={{ mt: 2 }}
        fullWidth
        label="ระยะเวลาการเก็บเกี่ยวใบกระท่อม (ต่อครั้ง)"
        name="harvestPeriod"
        value={form.harvestPeriod}
        onChange={handleChange}
      />
      <Divider sx={{ my: 3 }}>
        4. ส่วนที่ 4: ปัญหา ความต้องการ และการสนับสนุน
      </Divider>
      <Typography sx={{ m: 1 }}>
        *ส่วนนี้เน้นการค้นหาความต้องการและปัญหาที่แท้จริงของเกษตรกร{" "}
      </Typography>
      <Typography sx={{ m: 1 }}>
        *ปัญหา/อุปสรรคหลักในการทำการเกษตร: (เลือกได้หลายข้อ){" "}
      </Typography>
      <TextField
        fullWidth
        label="ด้านดิน/น้ำ/ภูมิอากาศ (ภัยแล้ง/น้ำท่วม/ดินเสื่อม)"
        name="problemSoilWaterClimate"
        value={form.problemSoilWaterClimate}
        onChange={handleChange}
      />
      <TextField
        sx={{ mt: 2 }}
        fullWidth
        label="ด้านโรค/ศัตรูพืช"
        name="problemDisease"
        value={form.problemDisease}
        onChange={handleChange}
      />
      <TextField
        sx={{ mt: 2 }}
        fullWidth
        label="ด้านต้นทุน/ราคาปัจจัยการผลิต"
        name="problemCost"
        value={form.problemCost}
        onChange={handleChange}
      />

      <TextField
        sx={{ mt: 2 }}
        fullWidth
        label="ด้านแรงงาน (ขาดแคลน/ค่าแรงสูง)"
        name="problemLabor"
        value={form.problemLabor}
        onChange={handleChange}
      />

      <TextField
        sx={{ mt: 2 }}
        fullWidth
        label="ด้านการตลาด (ราคา/การจำหน่าย)"
        name="problemMarket"
        value={form.problemMarket}
        onChange={handleChange}
      />

      <TextField
        sx={{ mt: 2 }}
        fullWidth
        label="หรือปัญหาด้านอื่นโปรดระบุ"
        name="problemOther"
        value={form.problemOther}
        onChange={handleChange}
      />

      <Box sx={{ mt: 4 }} display="flex" gap={2} justifyContent="flex-end">
        <Button variant="contained" onClick={handleSubmit}>
          บันทึก
        </Button>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          ยกเลิก
        </Button>
      </Box>
    </Box>
  );
}
